/**
 * Written testimonials from Russ's students. Originally collected from
 * a mix of email, Facebook, and the legacy WP site. Google reviews
 * (with structured ratings) live separately in
 * `src/app/reviews/google-reviews.generated.ts`.
 */

export interface WrittenTestimonial {
  readonly author: string;
  readonly date?: string;
  readonly datetime?: string;
  readonly text: string;
  /**
   * Trimmed/cleaned version for compact contexts like the home row; falls back
   * to `text` when absent. The full verbatim `text` is always preserved for
   * dedicated testimonials pages and future surfaces.
   */
  readonly short?: string;
  /**
   * Stable selector key. Only assigned to the entries the home "What students
   * say" trio pulls by identity, so the selection survives array reordering
   * (and disambiguates duplicate authors when needed). Most entries have no key.
   */
  readonly key?: string;
}

export const WRITTEN_TESTIMONIALS: readonly WrittenTestimonial[] = [
  {
    author: 'David Buice',
    date: '9/15/2012',
    datetime: '2012-09-15',
    text: "The knowledge of the bass and music that Russ Possesses could not be contained in a dozen books and or videos. It was my pleasure to have been a part of this clinic with Russ. His willingness to teach anyone who wants to know the many facets of the bass is truly a G- dsend. Teachers can't always play live or even improvise, then there are live players that can't always teach. Russ is the whole package.",
  },
  {
    author: 'Jon Packard',
    key: 'jon-packard',
    date: '3/6/2012',
    datetime: '2012-03-06',
    text: 'For anyone on the fence let me tell you that Russ is the REAL DEAL when it comes to both playing and teaching! I took lessons from Russ back inn the late 90s and what he taught me still impacts my playing daily.',
    short:
      'Russ is the real deal when it comes to both playing and teaching. I took lessons from him back in the late ’90s, and what he taught me still impacts my playing daily.',
  },
  {
    author: 'Alan Warrick',
    date: '3/10/2012',
    datetime: '2012-03-10',
    text: "He is the very best bass teacher I have ever taken a lesson from. It's get down to it hard work, fun but direct bass study. It really gets the job done. I have taken lessons from a lot of other players but they don't get the teaching done like that. I think he is also an awesome player.",
  },
  {
    author: 'Mike Stevens',
    text: '"This is completely unsolicited, but Russ Rodgers has got to be one of the greatest bass guitar teachers around. Many of the great bass players from ATL studied under Russ. Incredibly knowledgeable and one of the most professional people I\'ve ever met. If you need to go "there", he will take you!"',
    short:
      'One of the greatest bass teachers around. Incredibly knowledgeable, and one of the most professional people I’ve ever met.',
  },
  {
    author: 'Anthony Wellington',
    text: "Russell is a an amazing bass instructor! I'd recommend him to anybody. Incredible person too!!!",
  },
  {
    author: 'David Rosen',
    text: "I'd like to take a minute and just endorse Russell Rodgers as THE BEST bass guitar teacher out there! He literally took me through his diverse, fun, and comprehensive curriculum and provided me with both the building blocks and technical abilities to play just about any kind of music.",
  },
  {
    author: 'Mike Stevens',
    text: "For my bass playing friends on Facebook, please check out Russell Rodgers. Russ has been an educator, published author, performer, and studio musician for many years. Russ started the bass program at the Atlanta Institute of Music that is still being used today. His list of former students include many very well known professional bassists. Whether you are a beginner, intermediate, advanced, or pro player, Russ will improve your playing. Please check out a few of the demo videos on Russ's website, and you will understand exactly why he is one of the most respected and highly sought after bass educators today.",
  },
  {
    author: 'Stu Needel',
    text: '"Awesome Russell !!!! Not only great education and format, but superb audio on all levels. You, your bass, and your student. For any type of conferencing, audio quality is critical. I\'m listening on monitors and just sounds wonderful. Keep up the great work."',
  },
  {
    author: 'Tom Barney',
    text: "Hey there Russell, someone sent me one of your YouTube tutorials..just wanted to tell you that your an excellent instructor. it's really great thing that you do in educating players young and old. All the best!",
  },
  {
    author: 'Brooker Terry Robinson',
    text: 'Russ I just wanted to take a few moments to thank you. I just joined this FB group today and its crazy that you made this post and a member. Your videos were some of the first tutorials that I found as I searched Youtube for lessons when I started out. In particular your video on left hand technique and "set check and play" really helped me out a year ago when I first started. Many many many thanks! Cheers',
  },
  {
    author: 'Matt',
    text: '"I want to especially thank Russell Rodgers for helping me with my bass technique; I took several lessons from Russ; his expertise and direction is illustrated twice in this photo: (1) my left hand is \'flat\' across the fingerboard, with my thumb in its place; (2) my right thumb is properly dampening, as I THUMP! Thank you Russell Rodgers ;)"',
  },
  {
    author: 'Jay Rosenfeld',
    key: 'jay-rosenfeld',
    date: '6/15',
    text: '"I have been taking lessons from Russ for about a year and a half now. My playing still has a long way to go (have only been playing for about 5 years) but I know I will get to where I want to get with Russ. He has an excellent system that is suitable for beginner to advanced and great for any style from R and B, Blues, Rock to complex Jazz (what I am doing now). He is well organized and you always feel like you are moving in a logical progression. I have had a number of teachers since I started but I will be sticking with Russ. I recommend him highly!"',
    short:
      'I’ve been taking lessons from Russ for about a year and a half. He has an excellent system, well organized, and suitable from beginner to advanced — you always feel like you’re moving in a logical progression. I’ve had a number of teachers, but I’ll be sticking with Russ.',
  },
  {
    author: 'Billy Buchanan',
    text: 'How much time should a person put into perfecting their craft? My answer: As much time as it takes! When I was 19, I attended The Atlanta Institute of Music (eons ago..haha!), worked full time, and was playing in a band. I would work in the daytime, jump on the Marta train and go to school in the late afternoon, and then go to band practice at night. Many days I would show up to school without my assignments done. I vividly remember a conversation I had with my bass instructor, Russ Rodgers, about this. He asked me why I wasn\'t getting my school work done. I told him that I didn\'t have enough time because I was so busy. He said "Well you need to make time". I went on to explain in detail my exhausting schedule, thinking he would be sympathetic to my cause. I told him the only way that I could get it done is to get up really early before work, but then I would be losing sleep. His answer; "Then lose sleep!" Ha, that\'s not what I wanted to hear, but I understood the point he was making. We make time for the things that are REALLY important to us. From that day on, I started getting up at 6am everyday to get my studies done and to rehearse. It\'s a routine I still do to this day. – BB',
  },
  {
    author: 'Anthony East',
    date: 'Dec 13, 2011',
    datetime: '2011-12-13',
    text: '"Russ Rodgers is a true master of his instrument and a remarkably gifted teacher."',
    short:
      'Russ Rodgers is a true master of his instrument and a remarkably gifted teacher.',
  },
  {
    author: 'Randy Hoexter',
    text: 'My name is Randy Hoexter, and I am a musician, composer, and educator. I currently serve as Director of Education at the Atlanta Institute of Music and Media. I am writing this letter in support of Russ Rodgers. I had the pleasure of working with Russ at AIM for more than 25 years; his work as an educator was nothing short of spectacular. He brought knowledge, organization and passion to his teaching. Many of his students have had successful careers as musicians. I have also worked with Russ in the studio and on stage for a similar length of time. He was always prepared, positive, and easy to work with. He was always at the top of my list of musicians to recommend when work came available. His talent and work ethic are both as good as it gets. Russ is a fine and honorable person, and I would highly recommend him for any employment.',
  },
  {
    author: 'Scott Witkowski, Store Manager, Ken Stanton Music',
    text: 'It is with deep regret that we wish our friend Russ Rodgers farewell. For many years, Russ has been one of the most exceptional Music Educators we have ever known. His genuine concern for the musical growth of his students is unrivaled. We considered him an excellent asset to our Lesson Program. Through his efforts, he leaves our Company a better place than when he found it. He will be dearly missed.',
  },
  {
    author: 'Adam Maurasse',
    key: 'adam-maurasse',
    text: "I just wanted to thank you again for all that you've taught me over this past year and a half. Your lessons and methods have reconditioned my playing for the better. You're classes have given me so much that I know I'll have a lot to practice for years. Thanks again man!",
    short:
      'Thank you for all you’ve taught me this past year and a half. Your lessons and methods have reconditioned my playing for the better — I know I’ll have plenty to practice for years.',
  },
  {
    author: 'Heidi',
    text: 'I must tell you, that your all over the neck approach to that book is… genius! For me, I\'m not sure I ever would have gotten out of "the box" without it.',
  },
];

/**
 * The three testimonials echoed in the home "What students say" trio, in
 * display order (Jay Rosenfeld, Jon Packard, Adam Maurasse). These are the
 * concrete, journey/outcome-oriented endorsements (a multi-year arc, lasting
 * impact, reconditioned playing) rather than generic superlatives. Selected by
 * stable `key` so the strings live ONLY here — home renders the trimmed `short`
 * verbatim, and the selection survives source reordering.
 */
const HOME_TESTIMONIAL_KEYS = [
  'jay-rosenfeld',
  'jon-packard',
  'adam-maurasse',
] as const;

export const HOME_TESTIMONIALS: readonly WrittenTestimonial[] =
  HOME_TESTIMONIAL_KEYS.map((key) => {
    const found = WRITTEN_TESTIMONIALS.find((t) => t.key === key);
    if (!found) {
      throw new Error(`HOME_TESTIMONIALS: no testimonial with key "${key}"`);
    }
    return found;
  });
